import {
	AddItemCharacteristicMutation,
	AddItemCharacteristicValueMutation,
	DeleteItemCharacteristicMutation,
	DeleteItemCharacteristicValueMutation,
	UndeleteItemCharacteristicMutation,
	UndeleteItemCharacteristicValueMutation,
	UpdateItemCharacteristicMutation,
	UpdateItemCharacteristicValueMutation
} from "~/gql/mutations/itemCharacteristics.generated";
import { GetItemCharacteristicsQuery } from "~/gql/queries/itemCharacteristics.generated";

export const itemCharacteristicEndpoints = {
	AddItemCharacteristic: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: AddItemCharacteristicMutation) => res
	},
	AddItemCharacteristicValue: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: AddItemCharacteristicValueMutation) => res
	},
	DeleteItemCharacteristic: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: DeleteItemCharacteristicMutation) => res
	},
	DeleteItemCharacteristicValue: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: DeleteItemCharacteristicValueMutation) => res
	},
	GetItemCharacteristics: {
		providesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: GetItemCharacteristicsQuery) => res
	},
	UndeleteItemCharacteristic: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: UndeleteItemCharacteristicMutation) => res
	},
	UndeleteItemCharacteristicValue: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: UndeleteItemCharacteristicValueMutation) => res
	},
	UpdateItemCharacteristic: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: UpdateItemCharacteristicMutation) => res
	},
	UpdateItemCharacteristicValue: {
		invalidatesTags: ["ItemCharacteristics"] as AddTagTypes,
		transformResponse: (res: UpdateItemCharacteristicValueMutation) => res
	}
};
